import React from 'react';
import styled from 'styled-components/macro';

import InfoBoxTower from './InfoBoxTower';

import { ReactComponent as FeatureIconBed } from 'images/icons/feature-icon-bed.svg';
import { ReactComponent as FeatureIconMpr } from 'images/icons/feature-icon-mpr.svg';
import { ReactComponent as FeatureIconBath } from 'images/icons/feature-icon-bath.svg';
import { ReactComponent as FeatureIconCar } from 'images/icons/feature-icon-car.svg';


const InfoBoxHeader = ({ unitType, unit = null, level = null }) => {
    const { title: { rendered: unitTypeName }, acf: unitTypeData } = unitType;

    const unitDisplayName = unit?.title?.rendered;
    const unitTypeDisplayName = `TYPE ${unitTypeName}`;
    const levelName = level?.title?.rendered;

    return (
        <Container>
            <InfoBoxTower tower={unitTypeData.building} />

            <HeadingContainer>
                <Heading className="h3">
                    {unit ? unitDisplayName : unitTypeDisplayName}
                </Heading>

                {unit && (
                    <TypeInfo className="h6">
                        <TypeInfoItem>
                            {unitTypeDisplayName}
                        </TypeInfoItem>
                        <TypeInfoItem>
                            {levelName}
                        </TypeInfoItem>
                    </TypeInfo>
                )}
            </HeadingContainer>

            <Features>
                <FeatureItem>
                    <FeatureItemValue>{unitTypeData.bedrooms}</FeatureItemValue>
                    <FeatureIconBed />
                </FeatureItem>
                {unitTypeData.mpr && (
                    <FeatureItem>
                        <FeatureItemValue>MPR</FeatureItemValue>
                        <FeatureIconMpr />
                    </FeatureItem>
                )}
                <FeatureItem>
                    <FeatureItemValue>{unitTypeData.bathrooms}</FeatureItemValue>
                    <FeatureIconBath />
                </FeatureItem>
                <FeatureItem>
                    <FeatureItemValue>{unitTypeData.cars}</FeatureItemValue>
                    <FeatureIconCar />
                </FeatureItem>
            </Features>

        </Container>
    );
};


export default InfoBoxHeader;


const Container = styled.div`
    display: flex;
    flex-direction: column;
    gap: 2rem;
`;

const TypeInfo = styled.div`
    display: flex;
    color: ${props => props.theme.secondary_color};
    border-top: .1rem solid ${props => props.theme.secondary_color};
`;

const TypeInfoItem = styled.div`
    width: 50%;
    padding: .5rem 0;

    &:first-child {
        border-right: .1rem solid ${props => props.theme.secondary_color};
    }
`;

const HeadingContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 1rem;
    padding: 1rem 0;
    border-top: .1rem solid ${props => props.theme.secondary_color};
    border-bottom: .1rem solid ${props => props.theme.secondary_color};
    text-align: center;

    &:has(${TypeInfo}) {
        padding-bottom: 0;
    }
`;

const Heading = styled.div`
    color: ${props => props.theme.primary_color};
    text-transform: uppercase;
`;

const Features = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: stretch;
    color: ${props => props.theme.primary_color};
`;

const FeatureItem = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 0.5rem;

    svg {
        stroke: ${props => props.theme.primary_color};
    }
`;

const FeatureItemValue = styled.div`
    margin-bottom: auto;
`;
